import { createContext } from 'react';

export const UIContext = createContext();